import { useEffect, useState } from "react";
import styled from "styled-components";

export const ScrollTopButton = styled.button<{ $inline?: boolean }>`
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #fff;
  color: #01924f;
  font-size: 20px;
  border: none;
  cursor: pointer;
  box-shadow: 2px 1px 4px 0 rgba(0, 0, 0, 0.25);
  transition: background 0.3s ease, color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;


  position: absolute;
  bottom: 60px;
  right: -55px;


  @media (max-width: 1570px) {
    position: static;
    display: block;
    margin: -5px 0 0 auto;
  }

  &:hover {
    background: #01924f;
    color: #fff;
    transform: translateY(-3px);
    box-shadow: 4px 3px 10px 0 rgba(0, 0, 0, 0.3);
  }
`

function ScrollTopButtonComponent() {
    const [visible, setVisible] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const shouldShow = window.scrollY > window.innerHeight * 1.5;
        setVisible(shouldShow);
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
  
    if (!visible) return null;
  
    return (
      <ScrollTopButton onClick={scrollToTop} aria-label="Повернутись нагору">
        ↑
      </ScrollTopButton>
    );
  };
  
export default ScrollTopButtonComponent;